import { useQuery } from 'react-query';
import { getCompanies, getCompany, getSlackChannels } from '../../api/admin';
import useAuth from '../use-auth';
import { queryOptions } from '../use-hydra';

export function useGetCompanies() {
  const { getTokenSilently, isAuthenticated } = useAuth();

  const query = useQuery(
    ['get-companies', isAuthenticated],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      return getCompanies(token);
    },
    queryOptions
  );

  return query;
}

export function useGetCompany(id: number) {
  const { getTokenSilently, isAuthenticated } = useAuth();

  const query = useQuery(
    ['get-company', id, isAuthenticated],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      return getCompany(token, id);
    },
    queryOptions
  );

  return query;
}

export function useGetSlackChannels() {
  const { getTokenSilently, isAuthenticated } = useAuth();

  const query = useQuery(
    ['get-slack-channels', isAuthenticated],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      return getSlackChannels(token);
    },
    queryOptions
  );

  return query;
}
